import { useState, useCallback } from "react";
import {
  createSession,
  updateSession,
  deleteSession,
  type CreateSessionInput,
  type UpdateSessionInput,
} from "../services/sessionService";

export function useCreateSession() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const create = useCallback(async (input: CreateSessionInput) => {
    setLoading(true);
    setError(null);
    try {
      const id = await createSession(input);
      return id;
    } catch (err) {
      const e = err instanceof Error ? err : new Error("Create session failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { create, loading, error };
}

export function useUpdateSession() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const update = useCallback(
    async (sessionId: string, eventId: string, input: UpdateSessionInput) => {
      setLoading(true);
      setError(null);
      try {
        await updateSession(eventId, sessionId, input);
      } catch (err) {
        const e =
          err instanceof Error ? err : new Error("Update session failed");
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { update, loading, error };
}

export function useDeleteSession() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const remove = useCallback(async (eventId: string, sessionId: string) => {
    setLoading(true);
    setError(null);
    try {
      await deleteSession(eventId, sessionId);
    } catch (err) {
      const e =
        err instanceof Error ? err : new Error("Delete session failed");
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return { remove, loading, error };
}
